import React from 'react';

import { useIntersectionTracking } from '@reverbdotcom/commons/src/use_tracking';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

import CSPPriceGuideModule from './csp_price_guide_module';

import { CSP } from '../../../schemas/rql';

interface IExternalProps {
  csp: CSP;
  componentId?: string;
}

const COMPONENT_NAME = 'CSPPriceGuideModuleContainer';

export default function CSPPriceGuideModuleContainer({
  csp,
  componentId,
}: IExternalProps) {

  const intersectionTrackingRef = useIntersectionTracking({
    componentName: COMPONENT_NAME,
    eventName: MParticleEventName.CSPPriceGuideModuleObserved,
    cspId: csp.id,
    cspSlug: csp.slug,
  }, true);

  return (
    <div 
      id={componentId} 
      ref={intersectionTrackingRef}
    >
      <CSPPriceGuideModule csp={csp} />
    </div>
  );
}

